@switch (treatmentType) {
  @case (ConsultationTreatmentTypes.Peptide) {
    <app-vitamin-d-supplement-peptide />
  }
  @case (ConsultationTreatmentTypes.PeptideRenewal) {
    <app-vitamin-d-supplement-peptide />
  }
  @case (ConsultationTreatmentTypes.Rash) {
    <app-vitamin-d-supplement-rash />
  }
  @default {
    <app-vitamin-d-supplement />
  }
}
